"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NearbyResultItemComponent = void 0;
var React = require("react");
var classNames = require("classnames");
var NearbyCommuteMethods_1 = require("@/pages/detail/states/NearbyCommuteMethods");
var nearbyResultItemComponent = function (props) {
    var item = props.item;
    var t = props.t;
    var renderTags = function (tags) {
        var renderTag = function (tag, i) { return (React.createElement("div", { key: i, className: "o-tag" }, tag)); };
        if (!tags)
            return null;
        return React.createElement("div", { className: "c-distance-card__tags" }, tags.map(renderTag));
    };
    var renderTime = function (value, unit) {
        var h = 0;
        var m = value;
        if (unit.toLowerCase() === 'min') {
            if (value > 60) {
                h = Math.floor(value / 60);
                m = value - (h * 60);
            }
        }
        return (React.createElement("div", { className: "c-distance-card__time" },
            React.createElement("div", { className: "c-distance-card__duration" }, h > 0 ?
                (React.createElement(React.Fragment, null,
                    React.createElement("span", null, h),
                    "\u00A0",
                    React.createElement("span", { className: "c-distance-card__unit" }, "hr"),
                    "\u00A0",
                    React.createElement("span", null, m),
                    "\u00A0",
                    React.createElement("span", { className: "c-distance-card__unit" }, "min"))) :
                (React.createElement(React.Fragment, null,
                    React.createElement("span", null, m),
                    "\u00A0",
                    React.createElement("span", { className: "c-distance-card__unit" }, "min"))))));
    };
    var renderDuration = function (duration, i) {
        if (!duration.value)
            return null;
        var icon = duration.type === NearbyCommuteMethods_1.NearbyCommuteMethods.WALKING ? 'fas fa-walking' : 'fas fa-car';
        return (React.createElement("div", { key: i, className: "c-distance-card__geometry" },
            React.createElement("div", { className: "c-distance-card__method" },
                React.createElement("span", { className: icon })),
            renderTime(duration.value, duration.unit)));
    };
    var renderDurations = function (durations) {
        if (!durations || !durations.length)
            return null;
        return (React.createElement("div", { className: "c-distance-card__geometries" }, item.durations.map(renderDuration)));
    };
    var renderActions = function (props) {
        var srcLat = props.from.lat;
        var srcLng = props.from.lng;
        var destLat = props.item.position.lat;
        var destLng = props.item.position.lng;
        var directionUrl = "https://www.google.com/maps/dir/?api=1&origin=" + srcLat + "," + srcLng + "&destination=" + destLat + "," + destLng;
        return (React.createElement("div", { className: "c-distance-card__actions" },
            React.createElement("a", { target: "_blank", href: directionUrl, className: "o-btn o-btn--flat c-distance-card__action" },
                t.direction,
                " ",
                React.createElement("span", { className: "fal fa-directions" }))));
    };
    var renderCaption = function (caption) {
        return React.createElement("div", { className: "c-distance-card__caption" }, caption);
    };
    var renderTagsSection = function (tags) {
        return React.createElement("div", { className: "c-distance-card__extra" }, renderTags(tags));
    };
    var iconClass = "" + props.iconClass;
    var onResultItemClick = function () { return props.onResultItemClick(item, props.i); };
    var resultItemClass = classNames([
        'c-distance-card__item',
        {
            'c-distance-card__item--active': props.item.active,
        },
    ]);
    return (React.createElement("div", { onClick: onResultItemClick, className: resultItemClass },
        React.createElement("div", { className: "c-distance-card__icon" },
            React.createElement("span", { className: "c-distance-card__iconwarp", style: { backgroundColor: props.backgroundColor } },
                React.createElement("span", { className: iconClass }))),
        React.createElement("div", { className: "c-distance-card__body c-distance-card__body--column" },
            React.createElement("div", { className: "c-distance-card__info" },
                React.createElement("div", { className: "c-distance-card__name" }, item.name),
                item.caption ? renderCaption(item.caption) : null,
                item.tags ? renderTagsSection(item.tags) : null),
            props.from ? renderDurations(item.durations) : null,
            props.from ? renderActions(props) : null),
        React.createElement("div", { className: "c-distance-card__caret" },
            React.createElement("span", { className: "fal fa-chevron-right" }))));
};
exports.NearbyResultItemComponent = nearbyResultItemComponent;
